import UAParser from 'ua-parser-js';
import { ApiHeaders, AuthScheme, MobileConnectionType, authHeader, isDev, localhost, protocol } from "../../config";
import { EOS, EXPlatform, SessionChannel } from "../types";
var getConectionType = function getConectionType() {
  if (navigator) {
    var _navigator$connection;
    var _ref = (_navigator$connection = navigator.connection) !== null && _navigator$connection !== void 0 ? _navigator$connection : {},
      effectiveType = _ref.effectiveType,
      type = _ref.type;
    // Only Chrome / Chrome Android / Samsung & WebView
    if (type === 'wifi') {
      return MobileConnectionType.Wifi;
    }
    // Doesnt work in Firefox and Safari
    if (effectiveType === 'slow-2g') {
      return MobileConnectionType.M_2G_EDGE;
    }
    if (effectiveType === '2g') {
      return MobileConnectionType.M_2G;
    }
    if (effectiveType === '3g') {
      return MobileConnectionType.M_3G;
    }
    if (effectiveType === '4g') {
      return MobileConnectionType.M_LTE;
    }
  }
  return MobileConnectionType.Unknown;
};
var getXPlatform = function getXPlatform() {
  var os = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var typeOs = os.toLowerCase();
  if (typeOs.includes(EOS.android)) {
    return EXPlatform.android;
  }
  if (typeOs.includes(EOS.ios)) {
    return EXPlatform.ios;
  }
  return os;
};
export var getUserAgentHeaders = function getUserAgentHeaders() {
  var headers = {};
  var _UAParser$getResult = new UAParser().getResult(),
    browser = _UAParser$getResult.browser,
    device = _UAParser$getResult.device,
    os = _UAParser$getResult.os;
  var connectionType = getConectionType();
  if (browser !== null && browser !== void 0 && browser.name) {
    headers[ApiHeaders.Source] = browser.name;
  }
  if (os.name) {
    headers[ApiHeaders.Platform] = getXPlatform(os.name);
  }
  if (os.version) {
    headers[ApiHeaders.OsVersion] = os.version;
  }
  if (device && device.type === 'tablet' || device.type === 'mobile') {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    headers[ApiHeaders.PhoneModel] = "".concat(device.vendor, " ").concat(device.model);
  }
  if (connectionType) {
    headers[ApiHeaders.ConnectionType] = connectionType === null || connectionType === void 0 ? void 0 : connectionType.toString();
  }
  return headers;
};
export var getHeaders = function getHeaders(_ref2) {
  var token = _ref2.token,
    _ref2$authType = _ref2.authType,
    authType = _ref2$authType === void 0 ? AuthScheme.Captcha : _ref2$authType,
    _ref2$zoneType = _ref2.zoneType,
    zoneType = _ref2$zoneType === void 0 ? 'unauthorized' : _ref2$zoneType;
  var headers = {};
  if (token && authType) {
    // TODO: удалить после отписки приписки от BIS
    var type = AuthScheme[authType];
    headers[authHeader[type]] = token;
    headers[zoneType === 'unauthorized' ? ApiHeaders.Scheme : ApiHeaders.AuthScheme] = type;
  }
  return headers;
};
export var getEndpoints = function getEndpoints(root) {
  var _window;
  var address = isDev ? localhost : root !== null && root !== void 0 ? root : (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.origin;
  var http = "".concat(protocol.http, "://").concat(address);
  var ws = "".concat(protocol.websocket, "://").concat(address, "/api/v1/session?channel=").concat(SessionChannel.App);
  return {
    http: http,
    ws: ws
  };
};
export var appendSessionSearchParams = function appendSessionSearchParams(_ref3) {
  var baseUrl = _ref3.baseUrl,
    token = _ref3.token,
    _ref3$authType = _ref3.authType,
    authType = _ref3$authType === void 0 ? AuthScheme.Captcha : _ref3$authType,
    _ref3$zoneType = _ref3.zoneType,
    zoneType = _ref3$zoneType === void 0 ? 'unauthorized' : _ref3$zoneType;
  var url = new URL(baseUrl);
  var userAgentHeaders = getUserAgentHeaders();
  if (token && authType) {
    // TODO: удалить после отписки приписки от BIS
    var type = AuthScheme[authType];
    url.searchParams.append(authHeader[type], token);
    url.searchParams.append(zoneType === 'unauthorized' ? ApiHeaders.Scheme : ApiHeaders.AuthScheme, type);
  }
  Object.keys(userAgentHeaders).forEach(function (key) {
    url.searchParams.append(key, userAgentHeaders[key]);
  });
  url.searchParams.append(ApiHeaders.IsWeb, 'true');
  return url.href;
};
export var errorConverter = function errorConverter(e) {
  var _response$data;
  var _ref4 = e !== null && e !== void 0 ? e : {},
    status = _ref4.status,
    data = _ref4.data,
    response = _ref4.response;
  var requestStatus = isDev ? response === null || response === void 0 ? void 0 : response.status : status;
  return {
    status: requestStatus !== null && requestStatus !== void 0 ? requestStatus : 400,
    message: isDev ? response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.message : data === null || data === void 0 ? void 0 : data.message
  };
};